<!--
 * @Author: 黄昱森
 * @LastEditors: Yu Weifeng weifeng.yu@gientech.com
 * @Description:
-->

<script>
import ChartBase from '../base.vue';
import { isEmpty, isObject } from 'lodash';
import * as echarts from 'echarts/core';
import {
  TitleComponent,
  DatasetComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BrushComponent,
  MarkLineComponent,
  MarkAreaComponent,
  MarkPointComponent
} from 'echarts/components';
import { ScatterChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
echarts.use([
  TitleComponent,
  DatasetComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BrushComponent,
  MarkLineComponent,
  MarkAreaComponent,
  MarkPointComponent,
  ScatterChart,
  CanvasRenderer,
  UniversalTransition
]);
export default {
  name: 'LcScatter',
  mixins: [ChartBase],
  props: {},
  data() {
    return {
      chartClass: ['lc-chart__scatter']
    };
  },

  mounted() {},
  methods: {
    getCurrentEcharts() {
      return echarts;
    },
    processChartData(data) {
      const options = this.mapOptions;
      let transformData = [];
      // 设置了映射字段 或者 数据里有name和value字段
      if (!isEmpty(options) || (isObject(data[0]) && data[0]['name'] && data[0]['value'])) {
        if ((options && options.type) || data[0]['type']) {
          const groupData = {};
          data.forEach(item => {
            //分组
            const groupType = item[options?.type || 'type'];
            groupData[groupType] = groupData[groupType] ?? [];
            groupData[groupType].push([item[options?.dimension || 'name'], item[options?.valueMap || 'value']]);
          });
          Object.keys(groupData).forEach(group => {
            transformData.push({ name: group, value: groupData[group] });
          });
        } else {
          let tempValues = [];
          data.forEach(item => {
            tempValues.push([item[options?.dimension || 'name'], item[options?.valueMap || 'value']]);
          });
          transformData.push({ name: '', value: tempValues });
        }
      } else {
        transformData = data;
      }

      this.chartData = transformData;
    },
    processOptions(options) {
      const series = this.chartData.map(serie => ({
        name: serie.name,
        ...options.series,
        data: serie.value
      }));
      options.series = series;
      this.chartOptions = options;
    }
  }
};
</script>
